/* eslint no-underscore-dangle: 0 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { Button, CardContent, Grid } from '@mui/material';

/* gql hooks */
import useGQL from 'hooks/useGQL';

// project imports
import MainCard from 'ui-component/cards/MainCard';

// assets
import Spinner from 'components/spinner';
import ERoutes from 'routes/ERoutes';
import BrandedAppPromoCodeTable from './tables';

// ==============================|| BRANDED APP PROMO CODE LIST ||============================== //

const BrandedAppPromoCodeList = ({ title = 'Branded App Promo Codes' }: { title?: string }) => {
    /* queries & mutations */
    const { LIST_BRANDED_APP_PROMO_CODES } = useGQL();

    /* local states */
    const [promoCodeList, setPromoCodeList] = useState([]);

    const { error, loading, data, refetch } = LIST_BRANDED_APP_PROMO_CODES();

    useEffect(() => {
        if (data?.listBrandedAppPromoCodes) {
            setPromoCodeList(data.listBrandedAppPromoCodes);
        }
        if (error) {
            console.log(error);
        }
    }, [data]);

    const handleRefetch = () => {
        refetch();
    };

    return (
        <MainCard title={title} content={false} sx={{ position: 'relative' }}>
            <Button
                variant="outlined"
                component={Link}
                to={ERoutes.brandedAppPromoCodeAdd}
                sx={{ position: 'absolute', top: '1rem', right: '1rem' }}
            >
                Create new
            </Button>
            <CardContent>
                <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                    <Grid item xs={12} />
                </Grid>
            </CardContent>

            {/* table */}
            {loading ? (
                <Spinner />
            ) : (
                <BrandedAppPromoCodeTable promoCodeList={promoCodeList} handleRefetch={handleRefetch} loading={loading} />
            )}
        </MainCard>
    );
};

export default BrandedAppPromoCodeList;
